import Swiper from 'swiper';
import { Pagination, EffectFade, Autoplay } from 'swiper/modules';

class BlockHomeHeading {
  constructor() {
    this._init();
  }

  _init() {
    this._sliders()
    this._readMore()
  }

  _sliders() {
    new Swiper('.home-heading__images', {
      modules: [EffectFade, Autoplay],
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 0,
      effect: 'fade',
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
    });
    new Swiper('.home-heading__list', {
      modules: [Pagination, EffectFade, Autoplay],
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 0,
      effect: 'fade',
      autoplay: {
        delay: 3000,
        disableOnInteraction: true,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  }

  _readMore() {
    const mthis = this;
    const readMoreButton = document.querySelector('.home-heading__read-more');
    if (readMoreButton) {
      readMoreButton.addEventListener('click', function (event: Event) {
        const button = event.target as HTMLElement;
        const parent = button.closest('.home-heading') as HTMLElement;
        const nextVisibleSection = mthis._getNextVisibleElement(parent);

        if (nextVisibleSection) {
          const header = document.querySelector('header');
          const headerHeight = header ? header.clientHeight : 0;
          const sectionTop = nextVisibleSection.getBoundingClientRect().top + window.scrollY;

          window.scrollTo({
            top: sectionTop - headerHeight,
            behavior: 'smooth',
          });
        }
      })
    }
  }

  _getNextVisibleElement(element: HTMLElement | null): HTMLElement | null {
    let nextElement = element?.nextElementSibling as HTMLElement | null;

    while (nextElement) {
      // Vérifier si l'élément est visible (display !== "none")
      if (window.getComputedStyle(nextElement).display !== "none") {
        return nextElement;
      }
      nextElement = nextElement.nextElementSibling as HTMLElement | null;
    }

    return null; // Aucun élément visible trouvé
  }
}
export const blockHomeHeading = new BlockHomeHeading();
